const PRODUCT_MAX_LENGTH = 200

export function savedCartName(lines, describe) {
  const names = (lines || [])
    .map(line => line?.name ?? line?.variant?.name)
    .filter(Boolean)

  if (!names.length) return null

  const product = names[0].trim().slice(0, PRODUCT_MAX_LENGTH)
  const others = names.length - 1

  return describe(others, { product, count: others })
}
